module.exports = __webpack_public_path__ + "img/tinyQR.c53dd023.png";